import { useNavigate } from "react-router";
import { useContext } from "react";
import PlayerProvider from "./PlayerProvider";

export type SiteInfo = {
    key: string,
    name: string,
    path: string
}

export const SITE_INFO_TROK : SiteInfo = { key: 'stetrok', name: 'Triple Oaks', path: '/tripleoaks' }; 
export const SITE_INFO_XANM : SiteInfo = { key: 'stexanm', name: 'Xtreme Anime', path: '/xtremeanime' };
export const SITE_INFO_TACO : SiteInfo = { key: 'stetaco', name: 'Taco Bongo', path: '/tacobongo' };
export const SITE_INFO_WTRK : SiteInfo = { key: 'stewtrk', name: 'WTROK Radio', path: '/wtrok' };
export const SITE_INFO_CRNN : SiteInfo = { key: 'stecrnn', name: 'Cryptid News', path: '/cnn' };
export const SITE_INFO_PHRK : SiteInfo = { key: 'stephrk', name: "Phrank's Cranks", path: '/phrankscranks' };

export const ALL_SITE_INFOS : SiteInfo[] = [
    SITE_INFO_TROK,
    SITE_INFO_TACO,
    SITE_INFO_WTRK,
    SITE_INFO_XANM,
    SITE_INFO_CRNN,
    SITE_INFO_PHRK
];

export function GetSiteInfo(key: string) : SiteInfo|undefined
{
    return ALL_SITE_INFOS.find(i => i.key === key);
}